export const lightTheme = {
  bg: "#0B0F19", // deep dark navy
  bgLight: "#121826", // slightly lighter surface
  primary: "#00F5D4", // neon teal
  secondary: "#7B61FF", // soft neon purple

  disabled: "#4B5563",
  menubar: "#06090F",
  navbar: "#0F172A",
  arrow: "#9CA3AF",

  menu_primary_text: "#E5E7EB",
  menu_secondary_text: "#9CA3AF",

  table_header: "#111827",

  text_primary: "#F9FAFB",
  text_secondary: "#9CA3AF",

  card: "#111827",
  black: "#000000",
  white: "#FFFFFF",

  shadow: "#00F5D420", // subtle neon glow shadow

  green: "#00F5A0",
  yellow: "#FFD60A",
  red: "#FF4D6D",
  orange: "#FF9F1C",

  popup: "#0F172A",
  popup_text_primary: "#F9FAFB",
  popup_text_secondary: "#9CA3AF",

  output_node: "#1F2937",
};

export const softLightTheme = {
  bg: "#fffef5", // soft white background
  bgLight: "#fffef5",

  primary: "#FFC42E", // main yellow
  secondary: "#DE3134", // strong orange/red accent

  disabled: "#D1D5DB",

  menubar: "#FFF4D6", // light yellow tint
  navbar: "#FFFFFF",
  arrow: "#9CA3AF",

  menu_primary_text: "#1F2937",
  menu_secondary_text: "#6B7280",

  table_header: "#FFF7E6", // subtle warm tone

  text_primary: "#1A1A1A",
  text_secondary: "#6B7280",

  card: "#FFFFFF",

  black: "#000000",
  white: "#FFFFFF",

  shadow: "#00000012",

  green: "#22C55E",
  yellow: "#FFC42E",
  red: "#DE3134",
  orange: "#F97316",

  popup: "#FFFFFF",
  popup_text_primary: "#1F2937",
  popup_text_secondary: "#6B7280",

  output_node: "#FFE8A3", // soft yellow node background
};
